import {
  Component,
  OnInit,
  ElementRef,
  HostListener,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MapService } from 'src/app/services/map.service';
import { DataService } from 'src/app/services/data.service';
import { InfoBarMapViewService } from 'src/app/services/info-bar-map-view.service';
import { layerlist } from 'src/app/constant/maplayers';
import { applyRememberedMapLayer, rememberMapLayer } from 'src/app/constant/map-layer-memory';
import { CityMapService } from 'src/app/services/city-map.service';
import { Map } from 'ol';
import { EventsKey } from 'ol/events';
import { unByKey } from 'ol/Observable';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { ToastService } from 'src/app/services/toast.service';
import { PlayerStoryComponent } from 'src/app/modal/player-story/player-story.component';
import { CityWebDataService } from 'src/app/services/city-web-data.service';
import { Subscription, forkJoin } from 'rxjs';
import { CategoryPlayerViewModalComponent } from 'src/app/modal/category-player-view-modal/category-player-view-modal.component';
import { PlayerViewService } from 'src/app/services/player-view.service';
import { NoteListComponent } from 'src/app/modal/note-list/note-list.component';
import {
  biomeRanges,
  elevationRanges,
  WORLD_TUMBLER_URL,
} from 'src/app/constant/constant';
import { MapDataService } from 'src/app/services/map-data.service';
import { WikiService } from 'src/app/services/wiki.service';
import { FavoriteRecordsService } from 'src/app/services/favorite-records.service';
import { ContentData, FavoriteRecord } from '../content-creator/add-content/models/content.model';
import { PlaceContentModalComponent } from 'src/app/modal/place-content-modal/place-content-modal.component';
import { StoreLinkService } from 'src/app/services/marketplace/store-link.service';
import { MapSelectionService } from 'src/app/services/map-selection.service';
import { MapEntitySelection, MapEntityType } from 'src/app/models/map-entity.model';

type MapLevel = 'World' | 'Realm' | 'Region' | 'Locale' | 'Town' | 'Street';

@Component({
    selector: 'app-mapview',
    templateUrl: './mapview.component.html',
    styleUrls: ['./mapview.component.scss', './map-screen.shared.scss'],
    standalone: false
})
export class MapviewComponent implements OnInit, OnDestroy, AfterViewInit {
  map_id: any;
  game_id: any;
  map: Map;
  newLayers: any[];
  playerlistdata: any;
  layerlist: any = layerlist;
  sideInfoBar: boolean = false;
  partyInfo: any;
  isMenu1Open = false;
  isMenu2Open = false;
  userId: any;
  contentCreatorData: ContentData[] = [];
  cultureData: any;

  objectData: any;
  objectProperties: { label: string; value: any }[] = [];
  isDisplayCityMap: boolean = false;
  @ViewChild('map', { read: ElementRef, static: true }) mapElement: ElementRef;
  optionText: string = '';
  @ViewChild('sideContent', { read: ElementRef, static: true })
  sideInfoElement: ElementRef;
  playerCreatorData: any;
  coordsArrOfPointsPlayer: any;
  coordsArrOfPointsUser: { coords: [number, number][], idArr: number[], content: ContentData[] };
  openContentCreation: boolean = false;
  cityCode: any;
  historyRecords: any;
  historyCityRecords: any;
  showDropdown: boolean = false;
  resizeListener: any;
  windowmapheight: number | string = '123px';
  isCultureVisible: boolean = true;
  isMapDetailsVisible: boolean = false;
  isCityDetailsVisible: boolean = false;
  cityData: any;
  /** Which content the consolidated right panel shows - whichever the user
   * triggered most recently (map-key entity vs. a map click). Not the
   * spec's [Item] [This spot] tabs yet (needs both active + a way to flip
   * between them) - this slice shows one at a time, follow-up work. */
  panelMode: 'entity' | 'spot' | null = null;
  legendData: any = [];
  legendFilter: string = ''; // spec §5c: filter box appears once a key passes 8 entries
  currentLayerName: string = 'state';
  cellDetailsOrder: string[] = [
    'City Present',
    'Elevation',
    'Depth',
    'Population',
    'State',
    'Province',
    'Culture',
    'Religion',
    'Biome',
    'Land Area',
    'Geozone',
    'Natural Resources',
    'Bonus Resources',
    'Farm Resources',
    'Mineral Resources',
    'Special Resources',
  ];

  cityDetailsSortArray: string[] = [
    'City Name',
    'Population',
    'District',
    'Capitol',
    'Port',
    'Citadel',
    'City Walls',
    'Market Place',
    'Religious Center',
  ];
  elevationRanges = elevationRanges;
  biomeRanges = biomeRanges;
  selectedOption: string = '';
  showItemDetailsBox: boolean = false;
  isHistoryAdded: boolean = false;
  sideMenuHeight: string;
  historySubscriprtion: Subscription;
  historyCitySubscriprtion: Subscription;
  menuPosition = { x: 0, y: 0 };
  newFavoriteCoordinates: [number, number] = [0, 0];
  showMenu: boolean = false;
  isRemovingFavorite: number | null = null;
  favroiteRecords: FavoriteRecord[] = [];
  map_name: string = '';
  isOnlyBack: boolean = false;
  isCityVisited: boolean = false;
  playInterval: any;
  currentLayerWikiName: string = 'state';
  isLoading: boolean = false;
  displayHeader: boolean = false;
  redirect_coords: string = '';
  constructor(
    private mapService: MapService,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private dataService: DataService,
    private storeLinks: StoreLinkService,
    private infoBarService: InfoBarMapViewService,
    private cityMapService: CityMapService,
    private coordinateService: CoordinatesService,
    private currentUserService: CurrentUserService,
    private toastService: ToastService,
    private cityDataService: CityWebDataService,
    private router: Router,
    private renderer: Renderer2,
    private playerViewService: PlayerViewService,
    private mapDataService: MapDataService,
    private wikiService: WikiService,
    private favoriteRecordsService: FavoriteRecordsService,
    private cdr: ChangeDetectorRef,
    private mapSelectionService: MapSelectionService,
  ) {}
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    // The map fills the window below the app header. The site footer is not
    // shown on this play screen (it used to leave an empty band under the map).
    // Measured from the header, not the map's own position (wrong when the
    // page arrived scrolled).
    const headerHeight = document.querySelector('app-header')?.getBoundingClientRect().height || 48;
    const height = Math.max(320, window.innerHeight - headerHeight);

    this.windowmapheight = height + 'px';
    this.sideMenuHeight = height + 30 + 'px';
  }

  @HostListener('window:click', ['$event'])
  onClick(event: any) {
    if (
      this.mapElement &&
      this.mapElement.nativeElement.contains(event.target as HTMLElement)
    ) {
      if (this.openContentCreation) {
        this.mapService.handleMapContentClick(true, false, true, false);
        this.openContentCreation = false;
      }
      this.infoBarService.dataRetriver$.subscribe((data) => {
        if (!data) return;

        // According to the new InfoBarMapViewService, data = { resource_values, burg_values }
        const cell = data.resource_values;
        const burg = data.burg_values;
        if (!this.map_name) {
          this.map_name = cell.map_name;
        }

        // CELL DETAILS (right panel)
        this.objectData = {
          'City Present': burg ? 'Yes' : 'None',
          Culture: cell.culture,
          Religion: cell.religion,
          State: cell.state,
          Province: cell.province,
          Biome: cell.biome,
          Elevation: cell.elevation + ' ft' || 'NA',
          Depth: cell.depth + ' ft' || 'NA',
          Population: cell.population,
          'Natural Resources': cell.basic_resources,
          'Bonus Resources': cell.bonus_resources,
          'Mineral Resources': cell.mineral_resources,
          'Farm Resources': cell.farm_resources,
          'Special Resources': cell.special_resources,
        };
              if (this.objectData.Elevation === 'undefined ft' || this.objectData.Elevation === '0 ft') {
        delete this.objectData.Elevation;
      }
      if (this.objectData.Depth === 'undefined ft' || this.objectData.Depth === '0 ft') {
        delete this.objectData.Depth;
      }

        // CITY DETAILS (left panel)
        if (burg) {
          this.cityData = {
            'City Name': burg.burg || burg.Burg,
            Capitol: burg.capital || burg.Capital || 'No',
            Citadel: burg.citadel || burg.Citadel || 'No',
            Port: burg.port || burg.Port || 'No',
            'Market Place': burg.Plaza || 'No',
            'City Walls': burg.walls || burg.Walls || 'No',
            'Religious Center':
              burg.Temple && burg.Temple.length > 0 ? 'Yes' : 'No',
            'Shanty Town':
              burg['Shanty Town'] && burg['Shanty Town'].length > 0
                ? 'Yes'
                : 'No',
            Population: burg.population || burg.Population || cell.population,
          };
          this.isCityDetailsVisible = true;
          this.isMapDetailsVisible = true;
        } else {
          this.cityData = null;
          this.isCityDetailsVisible = false;
          this.isMapDetailsVisible = true;
        }
        this.panelMode = 'spot'; // consolidated right panel (Phase 3 slice 2) takes over display
        this.cdr.detectChanges();
      });

    } else if (
      this.sideInfoElement &&
      this.sideInfoElement.nativeElement.contains(event.target as HTMLElement)
    ) {
      this.sideInfoBar = true;
    }
    //else this.sideInfoBar = false;
  }

  getLegendDataLocal(mapcode: string, layer_name: string) {
    this.dataService
      .getLegendData(mapcode, layer_name)
      .subscribe((data: { res: any[] }) => {
        if (data.res.length > 0) {
          this.legendData = data.res;
          this.processLegendData(this.legendData);
        } else {
          this.legendData = [];
        }
      
          this.cdr.detectChanges();}, (error) => {
        console.error('Error fetching legend data:', error);
        this.toastService.showSuccess("We couldn't load the map legend.", 'danger');
      
          this.cdr.detectChanges();});
  }

  ngAfterViewInit(): void {
    this.mapService.removeOldMap();
    this.resetLayers();

    this.mapService.map.setTarget(
      this.elementRef.nativeElement.querySelector('#map'),
    );
    this.updateMapLevel();
    this.mapLevelListenerKey = this.mapService.map.getView().on('change:resolution', () => {
      this.updateMapLevel();
      this.cdr.detectChanges();
    });
    this.entitySelectionSubscription = this.mapSelectionService.selectionChanges.subscribe((sel) => {
      this.entitySelection = sel;
      if (sel) this.panelMode = 'entity'; // consolidated right panel (Phase 3 slice 2)
      this.cdr.detectChanges();
    });

    // Simulate window resize

    this.map_id = this.route.snapshot.paramMap.get('map_id');
    this.game_id = this.route.snapshot.paramMap.get('game_id');
    this.sendCurrentTimeOfPlay(this.game_id);
    this.playInterval = setInterval(() => {
      this.sendCurrentTimeOfPlay(this.game_id);
    }, 100000);
    this.getLegendDataLocal(this.map_id, this.currentLayerName);

    this.cityMapService.cityMapVisible$.subscribe((data: any) => {
      if (data.visible === true) {
        this.isDisplayCityMap = data.visible;
        // Import necessary modules if required
      }
    
          this.cdr.detectChanges();});

    this.playerList();
    this.getRouteQueryParams();
    this.getPartyLocationHistory(
      this.map_id,
      this.game_id,
      this.isHistoryAdded,
    );

    setTimeout(() => {
      document.getElementsByClassName('main-wrapper')[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }, 0);
    this.historyRecordsCityAndWorld();
    this.getAllRecords();

    setTimeout(() => {}, 1000);
  }

  sendCurrentTimeOfPlay(game_id) {
    this.dataService.sendCurrentTimeOfPlay(game_id).subscribe((data: any) => {
      if (data) {
      }
    
          this.cdr.detectChanges();});
  }

  resetLayers() {
    // open on the layer last chosen for this map (e.g. after Create new
    // content -> Back), otherwise State
    this.currentLayerName = applyRememberedMapLayer(this.route.snapshot.paramMap.get('map_id'));
  }
  processLegendData(legendData: any) {
    this.legendData = legendData.map((ele) => ({
      name: ele.name,
      full_name: ele.full_name,
      color: ele.color,
    }));
  }

  private getMapName(): void {
    this.mapService.mapList$.subscribe({
      next: (data) => {
        if (data) {
          this.map_name = data.find(
            (map) => map.map_id == this.map_id,
          )?.map_name;
        } else {
          this.mapService.getMapList();
        }
      
          this.cdr.detectChanges();},
      error: (error) => {
        console.error('Error fetching map list:', error);
      
          this.cdr.detectChanges();},
    });
  }

  processCultureData(cultureData: any) {
    this.cultureData = cultureData.map((ele) => ({
      name: ele.name,
      color: ele.color,
    }));
  }
  ngOnInit() {
    window.scrollTo(0, 0);
    this.onResize();
    history.pushState(null, '', location.href);
    window.onpopstate = () => {
      history.go(1); // disables going back
    };
    window.dispatchEvent(new Event('resize'));
    this.map_id = this.route.snapshot.paramMap.get('map_id');
    this.game_id = this.route.snapshot.paramMap.get('game_id');
    this.getMapName();

    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.userId = data.id;
        this.fetchFavoriteLocations();
      }
    
          this.cdr.detectChanges();});

    this.coordinateService.contentRecordsUpdated$.subscribe((data) => {
      if (data) {
        this.contentCreatorData = data;
        this.coordsArrOfPointsUser = this.extractCoordinatesFromPins(
          this.contentCreatorData,
        );
        this.mapService.addDifferentContentPin(
          false,
          this.coordsArrOfPointsUser,
          false,
        );
      }
    
          this.cdr.detectChanges();});
  }

  getRouteQueryParams(): void {
    this.route.queryParams.subscribe((params) => {
      this.isOnlyBack = false;
      if (params['isonlyback'])
        this.isOnlyBack = params['isonlyback'] == 'true';
      if (params['displayHeader'])
        this.displayHeader = params['displayHeader'] == 'true';
      if (params['isCityVisited'])
        this.isCityVisited = params['isCityVisited'] == 'true';
      if (this.game_id === 'undefined') {
        this.game_id = null;
      }
      if (params['redirect_coords'] && params['redirect_coords'] != 'null' && params['redirect_coords'] != 'undefined') {
        this.redirect_coords = params['redirect_coords'];
      }
      const obj = {
        map_id: this.map_id,
        type: 'Master',
        game_id: this.game_id,
        cityBackNavigate: 'mapview',
        isFitExtent: false,
        is_movement: !this.displayHeader,
      };
      this.mapService.loadlayers(obj);
      this.mapService.bindSingleClick();
      if (this.redirect_coords) {
        this.mapService.zoomToRedirectCoordsMain(this.redirect_coords);
      }
      localStorage.setItem('mapObject', JSON.stringify(obj));
      this.intializeUserSubscription();
    
          this.cdr.detectChanges();});
  }

  private intializeUserSubscription() {
    this.currentUserService.currentUser.subscribe({
      next: (data) => {
        if (data) {
          this.userId = data.id;
          this.getpartybygame(
            this.displayHeader,
            this.isCityVisited,
            this.userId,
          );
        }
      
          this.cdr.detectChanges();},
      error: (err) => {
        console.error('Error fetching current user:', err);
      
          this.cdr.detectChanges();},
    });
  }

  getpartybygame(isOnlyBack: boolean, isCityVisited: boolean, userId: any) {
    this.dataService
      .getpartybygame(this.game_id, userId)
      .subscribe((data: any) => {
        if (data) {
          this.partyInfo = data;
          this.mapService.addListofPointsmaptoken(
            [data],
            'gamemaster',
            isOnlyBack,
            isCityVisited,
          );
          if (!isCityVisited) {
          }
        }
      
          this.cdr.detectChanges();});
  }

  journalCheckBoxChange(event, index) {
    const journalEntry = this.historyRecords.find(
      (entry) => entry.id == event.target.value,
    );
    journalEntry.selected = event.target.checked;
    if (!journalEntry.selected) {
      this.mapService.removeRedLineOfPath(journalEntry);
    } else {
      this.mapService.addLineOfPath(journalEntry);
    }
  }

  cellDetailsSort = (a: any, b: any): number => {
    const order = this.cellDetailsOrder;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  cityDetailsSort = (a: any, b: any): number => {
    const order = this.cityDetailsSortArray;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  playerList() {
    this.dataService.playerList(this.game_id).subscribe((data: any) => {
      if (data) {
        this.playerlistdata = data.character_details;
        this.cdr.detectChanges();
        // this.mapService.addListofPoints(this.playerlistdata)
        // if (this.playerlistdata.length > 0) {
        //   this.playerlistdata.map((item) => {});
        //   const addmodalRef = this.modalService.open(
        //     PlayersCharacterListComponent,
        //     {
        //       size: 'xl',
        //       backdrop: 'static',
        //       centered: true,
        //     }
        //   );

        //   addmodalRef.componentInstance.playerListdata = this.playerlistdata;
        // }
      }
    });
  }
  historyRecordsCityAndWorld() {
    this.historyCitySubscriprtion =
      this.coordinateService.historyCityRecords$.subscribe(
        (historyCityRecords) => {
          if (
            historyCityRecords &&
            typeof historyCityRecords === 'object' &&
            typeof historyCityRecords === 'object'
          ) {
            this.historyCityRecords = historyCityRecords;
            this.historyCityRecords = historyCityRecords;
            this.sortHistoryRecords(this.historyCityRecords);
            this.mapService.addCityConstantLine(this.historyCityRecords, true);
          } else {
            this.historyCityRecords = [];
          }
          this.cdr.detectChanges();
        },
      );
    this.historySubscriprtion =
      this.coordinateService.historyRecords$.subscribe((historyRecords) => {
        if (historyRecords && typeof historyRecords === 'object') {
          this.historyRecords = historyRecords;

          this.historyRecords = historyRecords;
          this.historyRecords = this.historyRecords.map((item) => {
            item.selected = false;
            return item;
          });
          this.mapService.addConstantMovmentLine(this.historyRecords, true);
        } else {
          this.historyRecords = [];
        }
        this.cdr.detectChanges();
      });
  }

  getContentDataOfPlayersByMapCode() {
    this.dataService
      .getContentDataOfPlayersByMapCode(this.map_id)
      .subscribe((data: any) => {
        if (data) {
          this.playerCreatorData = data.res;
          this.playerCreatorData = this.playerCreatorData.filter(
            (ele) => ele.user_id !== this.userId,
          );
          const rawCoords = this.playerCreatorData.map(
            (ele) => ele.coordslocationarr,
          );
          const parsedCoords = this.parseStringCoordinates(rawCoords);
          this.coordsArrOfPointsPlayer = {
            coords: parsedCoords,
            idArr: this.playerCreatorData.map((ele) => ele.id || 0),
          };
          this.mapService.addDifferentContentPin(
            false,
            this.coordsArrOfPointsPlayer,
            true,
            this.playerCreatorData,
          );
        }
      
          this.cdr.detectChanges();});
  }

  getContentByMapCode() {
    this.dataService
      .getContentDataByMapId(this.userId, this.map_id)
      .subscribe((data: { results: ContentData[] }) => {
        if (data.results) {
          this.contentCreatorData = data.results;

          this.coordsArrOfPointsUser = this.extractCoordinatesFromPins(
            this.contentCreatorData,
          );

          this.mapService.addDifferentContentPin(
            false,
            this.coordsArrOfPointsUser,
            false,
          );
          this.cdr.detectChanges();
        }
      }, (error) => {
        console.error('Error fetching content creator data:', error);
        this.toastService.showSuccess("We couldn't load this map's content.", 'danger');
      
          this.cdr.detectChanges();});
  }
  getAllRecords() {
    forkJoin({
      contentCreator: this.dataService.getContentDataByMapId(
        this.userId,
        this.map_id,
      ),
      mapContentCreator: this.dataService.getContentDataOfPlayersByMapCode(
        this.map_id,
      ), // <-- your 2nd API here
    }).subscribe(
      (result: {
        contentCreator: { results: ContentData[] };
        mapContentCreator: { res: any[] };
      }) => {

        if (result.contentCreator) {
          ;
          this.contentCreatorData = result.contentCreator.results;
          this.coordsArrOfPointsUser = this.extractCoordinatesFromPins(
            this.contentCreatorData,
          );
          // Perform your action with the data
          this.mapService.addDifferentContentPin(
            true,
            this.coordsArrOfPointsUser,
            false,
          );

          // if (result.mapContentCreator.res) {
          // // Do something with the second API result
          //   this.playerCreatorData = result.mapContentCreator.res;
          //   this.playerCreatorData = this.playerCreatorData.filter(
          //     (ele) => ele.user_id !== this.userId,
          //   );
          //   const rawCoords = this.playerCreatorData.map(
          //     (ele) => ele.coordslocationarr,
          //   );
          //   const parsedCoords = this.parseStringCoordinates(rawCoords);
          //   this.coordsArrOfPointsPlayer = {
          //     coords: parsedCoords,
          //     idArr: this.playerCreatorData.map((ele) => ele.id || 0),
          //   };
          //   this.mapService.addDifferentContentPin(
          //     false,
          //     this.coordsArrOfPointsPlayer,
          //     true,
          //     this.playerCreatorData,
          //   );
          // }
        }

        // Or combine both results in some logic
        // ...
      
          this.cdr.detectChanges();},
    );
  }
  private extractCoordinatesFromPins(contentData: ContentData[]): { coords: [number, number][], idArr: number[], content: ContentData[] } {
    const coords: [number, number][] = [];
    const idArr: number[] = [];
    const content: ContentData[] = [];
    (contentData || [])
      .filter((ele) => ele.pins && ele.pins.length > 0)
      .forEach((ele) => {
        ele.pins
          .filter((pin) => String(pin.map_id) === String(this.map_id) && !pin.city_id)
          .forEach((pin) => {
            coords.push([
              parseFloat(pin.latitude as any),
              parseFloat(pin.longitude as any),
            ]);
            idArr.push(pin.id);
            content.push(ele);
          });
      });
    return { coords, idArr, content };
  }

  private parseStringCoordinates(coordsArray: string[]): any[] {
    return (coordsArray || [])
      .filter((ele) => !!ele)
      .map((element) => {
        const parts = element.split(',');
        return [parseFloat(parts[0]), parseFloat(parts[1])];
      });
  }

  getPartyLocationHistory(map_code, game_id, isHistoryAdded) {
    this.dataService
      .partylocationhistory(game_id, map_code)
      .subscribe((data: any) => {
        if (data) {
          if (
            data &&
            typeof data === 'object' &&
            data &&
            typeof data === 'object'
          ) {
            this.historyRecords = data;
            this.historyRecords = this.sortHistoryRecords(this.historyRecords);
            this.historyRecords = this.historyRecords.map((item) => {
              item.selected = false;
              return item;
            });
            this.mapService.addConstantMovmentLine(
              this.historyRecords,
              isHistoryAdded,
            );
          } else {
            this.historyRecords = [];
          }
        }
      
          this.cdr.detectChanges();});
  }

  editDetail(record, isCity) {
    const modalRef = this.modalService.open(PlayerStoryComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.updateStory.details = record.details;
    modalRef.componentInstance.updateStory.title = record.title;
    modalRef.result.then((result) => {
      if (result) {
        const recordDetails = result.value.details;
        const recordTitle = result.value.title;

        if (!isCity) {
          record.details = result.value.details;
          record.title = result.value.title;
          this.dataService.updatepartylocationhistory(record).subscribe(
            (data) => {
              if (data) {
                this.toastService.showSuccess(
                  'Game Party History Updated Successfully !!!',
                  'success',
                );
              }
            
          this.cdr.detectChanges();},
            (error) => {
              record.details = recordDetails;
              record.title = recordTitle;
            
          this.cdr.detectChanges();},
          );
        } else {
          record.details = result.value.details;
          record.title = result.value.title;
          this.cityDataService.updateCityPartyJournal(record).subscribe(
            (data) => {
              if (data) {
                this.toastService.showSuccess(
                  'City History Updated Successfully !!!',
                  'success',
                );
              }
            
          this.cdr.detectChanges();},
            (error) => {
              record.city_details = recordDetails;
              record.city_title = recordTitle;
            
          this.cdr.detectChanges();},
          );
        }
      }
    
          this.cdr.detectChanges();});
  }

  sortHistoryRecords(records: any[]) {
    if (Array.isArray(records)) {
      return records.sort((a, b) => {
        const dateA: any = new Date(a.timestamp);
        const dateB: any = new Date(b.timestamp);
        return dateB - dateA;
      });
    }
    return [];
  }

  removeCityLayer() {
    this.mapService.removeCityLayer();
    setTimeout(() => this.map?.updateSize(), 300);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize')); // Simulate window resize
    }, 300);

    this.isDisplayCityMap = false;
  }

  toggleMenu(menuId: string, menuOption?: boolean, optionTxt?: string) {
    if (menuId === 'menu1' && !menuOption) {
      this.isMenu1Open = !this.isMenu1Open;
      this.isMenu2Open = false;
    } else if (menuId === 'menu2') {
      this.isMenu2Open = menuOption;
      this.optionText = optionTxt;
    } else if (menuId === 'close') {
      this.isMenu1Open = false;
      this.isMenu2Open = false;
    }

    //return this.mapService.();
  }

  filterlayers(layers) {
    this.newLayers = layers.filter((lyr) => lyr.toggle == true);
    return this.newLayers;
  }

  changeToggleLayer(item: any) {
    // each layer toggles independently, so a bare map plus any combination of
    // overlays can be shown at once, rather than exactly one at a time
    item.checked = !item.checked;
    const currentLayer = this.newLayers.find((lyr) => lyr.checked === true);
    if (currentLayer) {
      rememberMapLayer(this.map_id, currentLayer.name);
      this.currentLayerName = currentLayer.name;
      this.currentLayerWikiName = currentLayer.label.toLowerCase();
      this.getLegendDataLocal(this.map_id, currentLayer.name);
    }
    this.mapService.filterAndToggleLayers(this.newLayers);
  }

  createContent() {
    this.isLoading = true;
    forkJoin({
      cellData: this.dataService.getCustomCellData({
        latitude: this.newFavoriteCoordinates[1],
        longitude: this.newFavoriteCoordinates[0],
        map_code: this.map_id,
      }),
      mapGenre: this.dataService.getMapGenre(this.map_id, this.game_id)
    }).subscribe({
      next: (result: any) => {
        this.isLoading = false;
        const data = result.cellData;
        const genreData = result.mapGenre;

        if (data) {
          const elevationRanges = this.buildElevationRange(data);
          const biomeRanges = this.processBiomeRanges(data);
          const payload: any = {
            biome: biomeRanges,
            elevation: elevationRanges,
          };

          if (genreData?.res) {
            payload.game_genre = genreData.res;
          }
          if (genreData?.game_system) {
            payload.game_system = genreData.game_system;
          }

          this.passFinalObjectToContentPage(payload);
        }
      
          this.cdr.detectChanges();},
      error: (err) => {
        this.isLoading = false;
        console.error(err);
      
          this.cdr.detectChanges();},
    });
  }

  passFinalObjectToContentPage(queryParamsObject: any) {
    this.mapDataService.setContentRangesData(queryParamsObject);
    this.router.navigate(['/add-edit-content'], {
      queryParams: {
        map_id: this.map_id,
        character_id: 23,
        backwordNavigate: this.router.url,
        coordinates: this.newFavoriteCoordinates?.join(','),
      },
    });
  }

  buildElevationRange(data: any) {
    const elevation =
      data?.elevation > 0 ? data.elevation : (data?.depth ?? NaN);

    // Always build the base object first
    const result: Record<string, boolean> = this.elevationRanges.reduce(
      (acc, range) => {
        acc[range] = false;
        return acc;
      },
      {} as Record<string, boolean>,
    );

    // Explicit early return for invalid elevation
    if (typeof elevation !== 'number' || Number.isNaN(elevation)) {
      return result;
    }

    for (const range of this.elevationRanges) {
      const match = range.match(/-?\d+/g);
      if (!match || match.length < 2) continue;

      const min = Number(match[0]);
      const max = Number(match[1]);

      if (elevation >= min && elevation <= max) {
        result[range] = true;
        break;
      }
    }

    return result;
  }

  ngOnDestroy(): void {
    window.onpopstate = null;
    this.mapService.removeOldMap();
    this.mapService.unbindSingleClick();
    this.historySubscriprtion?.unsubscribe();
    this.historyCitySubscriprtion?.unsubscribe();
    if (this.playInterval) clearInterval(this.playInterval);
    if (this.mapLevelListenerKey) unByKey(this.mapLevelListenerKey);
    this.entitySelectionSubscription?.unsubscribe();
  }

  editRecord(record) {
    this.mapService.handleMapContentClick(true, false, true, false, record);
  }

  deleteRecord(id) {
    this.dataService.deleteContentById(id).subscribe((data) => {
      if (data) {
        this.toastService.showSuccess(
          'Record Deleted Successfully !!!',
          'success',
        );
        this.getAllRecords();
      }
    
          this.cdr.detectChanges();});
  }

  openSideDropdownOption() {
    this.showDropdown = !this.showDropdown;
    this.selectedOption = '';
    this.showItemDetailsBox = false; // Toggles the dropdown visibility
  }

  setSelectOption(option: string) {
    this.selectedOption = option;
    this.showItemDetailsBox = true;
    this.showDropdown = false; // the list closes once a panel is chosen
  }

  toggleCultureList() {
    this.isCultureVisible = !this.isCultureVisible;
  }

  toggleMapDetails() {
    this.sideInfoBar = true;
    this.isMapDetailsVisible = !this.isMapDetailsVisible;
    return this.sideInfoBar;
  }

  toggleCityMapDetails() {
    this.sideInfoBar = true;
    this.isCityDetailsVisible = !this.isCityDetailsVisible;
    return this.sideInfoBar;
  }
  triggerZoomIn() {
    this.mapService.zoomIn();
  }

  triggerZoomOut() {
    this.mapService.zoomOut();
  }
  triggerTokenZoom() {
    this.mapService.zoomToExtent('playermap');
  }

  // --- Atlas Rail shell: named zoom level, rail mode, compass -----------------
  // Thresholds are the spec's proposals (worldtumbler-map-redesign-spec.md §4),
  // read against the real ladder zoom already shown in the UI today (the same
  // numbers the design-canvas mockups were labelled with) - align them to where
  // the map engine actually switches render styles once that's pinned down.
  private static readonly MAP_LEVEL_THRESHOLDS: [MapLevel, number][] = [
    ['Street', 20], ['Town', 17], ['Locale', 15], ['Region', 12], ['Realm', 9],
  ];
  mapLevel: MapLevel = 'World';
  mapLevelZoom = 0;
  railMode: 'map' | 'explore' = 'map';
  private mapLevelListenerKey: EventsKey | undefined;

  private updateMapLevel(): void {
    const zoom = this.mapService.map?.getView()?.getZoom();
    if (zoom == null) return;
    this.mapLevelZoom = zoom;
    const hit = MapviewComponent.MAP_LEVEL_THRESHOLDS.find(([, min]) => zoom >= min);
    this.mapLevel = hit ? hit[0] : 'World';
    this.railMode = this.mapLevel === 'Locale' || this.mapLevel === 'Town' || this.mapLevel === 'Street' ? 'explore' : 'map';
  }

  resetNorth(): void {
    this.mapService.map?.getView()?.setRotation(0);
  }

  // --- Atlas Rail Phase 2: single-select "Color map by" (spec §5a/§6) ------
  // Exclusive selection with an off state, replacing the old independent
  // multi-toggle (changeToggleLayer, still used nowhere now but left in
  // place - not deleting working code outside this method's scope). Reuses
  // the same filterlayers()/newLayers/filterAndToggleLayers() plumbing
  // changeToggleLayer already relied on.
  setColorBy(layer: any): void {
    if (layer.name === 'zones') return; // disabled - "Soon" per spec
    const group = this.filterlayers(this.layerlist);
    const turningOn = !layer.checked;
    group.forEach((l) => (l.checked = l.name === layer.name && turningOn));
    this.legendFilter = '';
    if (turningOn) {
      rememberMapLayer(this.map_id, layer.name);
      this.currentLayerName = layer.name;
      this.currentLayerWikiName = layer.label?.toLowerCase();
      this.getLegendDataLocal(this.map_id, layer.name);
    } else {
      this.currentLayerName = '';
      this.legendData = [];
    }
    this.mapService.filterAndToggleLayers(this.newLayers);
  }

  filteredLegendData(): any[] {
    const q = this.legendFilter.trim().toLowerCase();
    if (!q) return this.legendData;
    return this.legendData.filter((d: any) => (d.name || '').toLowerCase().includes(q));
  }

  closeSecondMenu() {
    this.showItemDetailsBox = false;
    this.selectedOption = '';
  }

  onRightClickPopup(event: MouseEvent) {
    event.preventDefault(); // Prevent the default context menu

    // keep the menu on screen near the right/bottom edges
    this.menuPosition.x = Math.min(event.clientX, window.innerWidth - 260);
    this.menuPosition.y = Math.min(event.clientY, window.innerHeight - 200);

    this.showMenu = true;

    this.newFavoriteCoordinates = this.mapService.map.getEventCoordinate(
      event,
    ) as [number, number];
  }

  saveToFavourite() {
    this.showMenu = false;
    const modalRef = this.modalService.open(CategoryPlayerViewModalComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.result.then((res) => {
      if (res) {
        const obj: any = {
          iconname: res.selectedIcon,
          game_id: this.game_id,
          character_id: res.character_id
            ? res.character_id.map((char) => char.character_id)
            : [this.game_id],
          geography:
            this.newFavoriteCoordinates[0].toString() +
            ',' +
            this.newFavoriteCoordinates[1].toString(),
          color: res.color,
          category: res.category,
          details: res.details,
          mapcode: this.map_id,
        };

        obj.citycode = this.cityCode;
        this.playerViewService.addLocationPointInfo(obj).subscribe((data) => {
          this.fetchFavoriteLocations();
        
          this.cdr.detectChanges();});
      }
    
          this.cdr.detectChanges();});
  }

  private fetchFavoriteLocations(): void {
    this.dataService.getFavroiteRecordsByMapId(this.userId, 'map').subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          this.mapService?.sharedLocationLayer?.getSource()?.clear();
          this.favroiteRecords = data;
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.favroiteRecords = [];
        this.toastService.showSuccess('Nothing here yet.', 'danger');
      
          this.cdr.detectChanges();},
    );
    this.favoriteRecordsService.favoriteRecords$.subscribe((data: FavoriteRecord[]) => {
      this.favroiteRecords = data || [];
      this.isRemovingFavorite = null;
      this.cdr.detectChanges();
    });
  }

  continuePlaying() {
    this.router.navigate(
      [
        '/city-map-view/' +
          Number(this.partyInfo.spawn_city) +
          '/' +
          this.map_id +
          '/' +
          (this.game_id ? this.game_id : 'null') +
          '/' +
          'null',
      ],
      {
        queryParams: {
          token: this.partyInfo.partytoken,
          isLoadToken: true,
          isPlaceToken: this.playerlistdata.current_location,
          backRoute: 'mapview',
        },
      },
    );
  }

  navigateToCityNameWiki() {
    this.wikiService.openCityWiki(
      this.cityData['City Name'],
      this.map_id,
      this.map_name,
    );
  }

  // --- Atlas Rail Phase 3 (slice 1): map-key entry selection -----------------
  // Clicking a key entry now selects it (spec §6: "highlight it on the map
  // and open its panel") instead of jumping straight to the wiki - Wiki is
  // one of the panel's two footer buttons now, not the click action itself.
  entitySelection: MapEntitySelection | null = null;
  entitySelectionLoading = false;
  private entitySelectionSubscription: Subscription;

  private static readonly ENTITY_TYPE_BY_LAYER: Record<string, MapEntityType> = {
    state: 'state', provinces: 'province', culture: 'culture', religions: 'religion', biomes: 'biome',
  };

  onDynamicDataClick(dataName: string): void {
    const type = MapviewComponent.ENTITY_TYPE_BY_LAYER[this.currentLayerName];
    if (!type) return; // Height/Zones have no per-entity panel
    this.selectEntityByTypeAndName(type, dataName);
  }

  /** Fetches the real record for a State/Province/Culture/Religion by name
   * and opens the panel - shared by map-key clicks (onDynamicDataClick) and
   * search results (selectSearchResult), which both resolve to a type+name
   * but get there differently. */
  selectEntityByTypeAndName(type: MapEntityType, dataName: string): void {
    this.entitySelectionLoading = true;
    this.cdr.detectChanges();
    const fetch$ =
      type === 'state' ? this.dataService.getStateData(this.map_id) :
      type === 'province' ? this.dataService.getProvinceData(this.map_id) :
      type === 'culture' ? this.dataService.getCultureData(this.map_id) :
      type === 'religion' ? this.dataService.getReligionData(this.map_id) : null;
    if (!fetch$) {
      // Biome: no dedicated entity endpoint yet, only the legend row itself
      this.mapSelectionService.select({ type, data: { name: dataName } });
      this.entitySelectionLoading = false;
      this.cdr.detectChanges();
      return;
    }
    fetch$.subscribe({
      next: (resp: { res: any[] }) => {
        const nameField = type === 'state' ? 'state' : type === 'province' ? 'province' : 'name';
        const match = (resp.res || []).find((e: any) => e[nameField] === dataName || e.full_name === dataName);
        this.mapSelectionService.select(match ? { type, data: match } : { type, data: { name: dataName } });
        this.entitySelectionLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.entitySelectionLoading = false;
        this.toastService.showSuccess('Could not load details.', 'danger');
        this.cdr.detectChanges();
      },
    });
  }

  /** Field rows for whichever entity type is selected, spec §7 field lists
   * trimmed to what the backend actually returns (see map-entity.model.ts). */
  entityFields(): { label: string; value: string }[] {
    const sel = this.entitySelection;
    if (!sel) return [];
    const d: any = sel.data;
    const num = (v: any) => (v == null ? '—' : Number(v).toLocaleString());
    switch (sel.type) {
      case 'state':
        return [
          { label: 'Full name', value: d.full_name || '—' },
          { label: 'Population', value: num(d.total_population) },
          { label: 'Area', value: d.area != null ? `${num(d.area)} sq mi` : '—' },
          { label: 'Cities', value: num(d.burgs) },
          { label: 'Capital', value: d.capital || '—' },
          { label: 'Main culture', value: d.culture || '—' },
        ];
      case 'province':
        return [
          { label: 'Full name', value: d.full_name || '—' },
          { label: 'State', value: d.state || '—' },
          { label: 'Population', value: num(d.total_population) },
          { label: 'Area', value: d.area != null ? `${num(d.area)} sq mi` : '—' },
          { label: 'Seat', value: d.capital || '—' },
        ];
      case 'culture':
        return [
          { label: 'Type', value: d.type || '—' },
          { label: 'Population', value: num(d.population) },
          { label: 'Area', value: d.area != null ? `${num(d.area)} sq mi` : '—' },
        ];
      case 'religion':
        return [
          { label: 'Type', value: d.type || '—' },
          { label: 'Deity', value: d.supreme_deity || '—' },
          { label: 'Followers', value: num(d.believers) },
          { label: 'Area', value: d.area != null ? `${num(d.area)} sq mi` : '—' },
        ];
      default:
        return [];
    }
  }

  entitySelectionName(): string {
    const d: any = this.entitySelection?.data;
    return d?.state || d?.province || d?.name || '';
  }

  closePanel(): void {
    this.mapSelectionService.clear();
    this.objectData = null;
    this.cityData = null;
    this.panelMode = null;
  }

  // --- Atlas Rail: real search (spec §3, replacing "Future enhancement..") ---
  // Scope narrowing by zoom level (search within the current Province/City at
  // Locale+) isn't built yet - that needs the Explore rail's pin data (Phase
  // 4), so every search still looks across all five backend types regardless
  // of zoom. Placeholder text still follows railMode so it reads honestly.
  searchQuery = '';
  searchResults: any[] = [];
  searchLoading = false;
  private searchDebounceTimer: any;

  get searchPlaceholder(): string {
    return this.railMode === 'explore' ? 'Search places…' : 'Search cities, states, cultures…';
  }

  onSearchInput(): void {
    clearTimeout(this.searchDebounceTimer);
    const q = this.searchQuery.trim();
    if (!q) {
      this.searchResults = [];
      return;
    }
    this.searchDebounceTimer = setTimeout(() => this.runSearch(q), 300);
  }

  runSearch(q: string): void {
    const query = (q ?? this.searchQuery).trim();
    if (!query || !this.map_id) return;
    this.searchLoading = true;
    this.dataService.mapSearch(this.map_id, query).subscribe({
      next: (results: any[]) => {
        this.searchResults = results || [];
        this.searchLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.searchResults = [];
        this.searchLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  selectSearchResult(result: any): void {
    this.searchQuery = '';
    this.searchResults = [];
    if (result.centroid) {
      this.mapService.map.getView().animate({ center: [result.centroid.lon, result.centroid.lat], duration: 400 });
    }
    // City results: zoom only for now - no city-by-id fetch wired to the
    // panel yet (cityData today only comes from the existing map-click
    // flow). State/Province/Culture/Religion: select + open the panel,
    // same as clicking the name in the map key.
    if (result.type !== 'city') {
      this.selectEntityByTypeAndName(result.type, result.name);
    }
  }

  clearSearch(): void {
    this.searchQuery = '';
    this.searchResults = [];
  }

  openWikiForSelection(): void {
    if (!this.entitySelection) return;
    const name = (this.entitySelection.data as any).full_name || (this.entitySelection.data as any).name
      || (this.entitySelection.data as any).state || (this.entitySelection.data as any).province;
    this.wikiService.openWiki(this.entitySelection.type, name, this.map_id, this.map_name);
  }

  /** Pans the map to the selection, via the real point the search endpoint
   * already resolves per entity (Cells ownership, not the entity's own
   * .geom - confirmed unreliable for State/Province/Culture/Religion, see
   * the backend contract doc #1). No bbox/zoom-to-fit yet (#5 there),
   * recentres at the current zoom. */
  zoomToSelection(): void {
    const sel = this.entitySelection;
    if (!sel) return;
    const name = (sel.data as any).state || (sel.data as any).province || (sel.data as any).name;
    if (!name) return;
    this.dataService.mapSearch(this.map_id, name, [sel.type === 'state' ? 'state' : sel.type]).subscribe({
      next: (results: any[]) => {
        const hit = results?.[0];
        if (hit?.centroid) this.mapService.map.getView().animate({ center: [hit.centroid.lon, hit.centroid.lat], duration: 400 });
      },
    });
  }

  navigateToWikiWorld(map_name?: string) {
    this.wikiService.openMapWiki(this.map_id, map_name || this.map_name);
  }

  hoveredResource: any = null;
  tooltipStyle: any = {};

  showResourceTooltip(event: MouseEvent, item: any): void {
    if (!item) return;
    this.hoveredResource = typeof item === 'string' ? { name: item } : item;
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const rect = target.getBoundingClientRect();
      const tooltipWidth = 330;
      const left = Math.max(10, rect.left - tooltipWidth - 15);
      const top = Math.max(10, Math.min(window.innerHeight - 240, rect.top - 20));
      this.tooltipStyle = {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }

  hideResourceTooltip(): void {
    this.hoveredResource = null;
  }

  isResourceField(key: string | any): boolean {
    const resourceKeys = [
      'Natural Resources',
      'Bonus Resources',
      'Farm Resources',
      'Mineral Resources',
      'Special Resources',
    ];
    return resourceKeys.includes(key);
  }

  splitResources(value: string | any): any[] {
    if (!value || value === 'None') return [];
    if (Array.isArray(value)) {
      return value.map((item) => {
        if (typeof item === 'string') {
          return { name: item, description: '', production: 0, economy: 0, rarity: 0, processing: 0 };
        }
        return item;
      });
    }
    if (typeof value === 'string') {
      if (value.toLowerCase() === 'none') return [];
      return value.split(',').map((v) => ({
        name: v.trim(),
        description: '',
        production: 0,
        economy: 0,
        rarity: 0,
        processing: 0
      }));
    }
    return [];
  }

  onResourceClick(resource: string): void {
    this.wikiService.openResourceWiki(resource);
  }

  isLinkField(key: string | any): boolean {
    const linkKeys = ['State', 'Province', 'Culture', 'Religion', 'Biome'];
    return linkKeys.includes(key);
  }

  navigateToDynamicLink(key: string | any, value: string | any): void {
    this.wikiService.openWiki(key, value, this.map_id, this.map_name);
  }

  toggleGMTools() {
    this.showMenu = false;
    this.selectedOption = 'GMTools';
    this.showItemDetailsBox = true;
  }

  addNote(isPrivate: boolean) {
    this.showMenu = false;
    this.showItemDetailsBox = false;
    this.selectedOption = '';
    this.openNoteModal(isPrivate);
  }

  openNoteModal(isPrivate: boolean) {
    const modalRef = this.modalService.open(NoteListComponent, {
      centered: true,
      backdrop: 'static',
      size: 'md',
    });

    modalRef.componentInstance.game_id = this.game_id;
    modalRef.componentInstance.noteType = isPrivate ? 'private' : 'public';
    modalRef.componentInstance.isFilter = false;
  }

  navigateToElevationLink() {
    const url = `${WORLD_TUMBLER_URL}/elevations/elevations`;
    window.open(url, '_blank');
  }

  processBiomeRanges(data: any) {
    let biome: string = data?.biome ?? '';

    // Normalize input biome to Title Case
    biome = biome
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    // Build base result object (all false)
    const result: Record<string, boolean> = this.biomeRanges.reduce(
      (acc, range) => {
        acc[range] = false;
        return acc;
      },
      {} as Record<string, boolean>,
    );

    // If biome is empty or invalid, return all false
    if (!biome) {
      return result;
    }

    // Exact match → set true
    if (result.hasOwnProperty(biome)) {
      result[biome] = true;
    }

    return result;
  }

  removeFromFavroite(record: FavoriteRecord) {
    this.isRemovingFavorite = record.wp_content_usage_id;

    this.dataService.saveContentToFavorites(this.userId, record.wp_content_usage_id).subscribe({
      next: (res: any) => {
        this.toastService.showSuccess(res.message, 'success');
        this.favoriteRecordsService.loadFavoriteRecords(this.userId, 'map', true);
      
          this.cdr.detectChanges();},
      error: () => {
        this.isRemovingFavorite = null;
      
          this.cdr.detectChanges();}
    });
  }

  openPlaceContentModal() {
    this.showMenu = false;
    const modalRef = this.modalService.open(PlaceContentModalComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });

    modalRef.componentInstance.map_id = this.map_id;

    modalRef.result.then((selectedContent: ContentData | null) => {
      if (selectedContent) {
        const payload = {
          wp_product_id: selectedContent.wp_product_id,
          content_id: selectedContent.id,
          wp_user_id: this.userId,
          context: 'map' as const,
          map_id: this.map_id,
          city_id: null,
          latitude: this.newFavoriteCoordinates[0],
          longitude: this.newFavoriteCoordinates[1],
          label: selectedContent.content_title
        };

        this.dataService.contentAttach(payload).subscribe({
          next: (res: any) => {
            this.toastService.showSuccess('Content placed.', 'success');
            this.getContentByMapCode(); // Refresh pins
          
          this.cdr.detectChanges();},
          error: (err) => {
            console.error('Error attaching content:', err);
            this.toastService.showSuccess("We couldn't place this content. Please try again.", 'danger');
          
          this.cdr.detectChanges();}
        });
      }
    
          this.cdr.detectChanges();});
  }

  browseWpStore() {
    // Opens the store filtered to this map's genre and game system. The
    // StoreLinkService opens the in-app store.
    this.showMenu = false;
    this.dataService.getMapGenre(this.map_id, this.game_id).subscribe((data: any) => {
      if (data?.res) {
        const actualGenre = data.res;
        const actualSystem = data.game_system; // Backend field is 'game_system'
        this.storeLinks.openStore({ genre: actualGenre, system: actualSystem });
      }
      else {
        this.storeLinks.openStore();
      }
      this.cdr.detectChanges();
    }, () => {
      this.storeLinks.openStore();
      this.cdr.detectChanges();
    });
  }

  constructParam(label: string, value: string) {
    const genreMapping: { [key: string]: string } = {
      'Science Fiction & Science Fantasy (Traveller, etc)': 'scifi',
      'Modern & Horror (Call of Cthulhu, etc)': 'modern-horror',
      'Fantasy (Dungeons & Dragons, etc)': 'fantasy'
    };

    const systemMapping: { [key: string]: string } = {
      'Dungeons and Dragons': 'dnd',
      'Pathfinder': 'pathfinder',
      'Warhammer': 'warhammer',
      'The One Ring': 'one-ring',
      '13th Age': '13th-age',
      'Dungeon Crawl Classic': 'dcc',
      'Shadow of the Demon Lord': 'shadow-demon',
      'Rolemaster': 'rolemaster',
      'Starfinder': 'starfinder',
      'Traveller': 'traveller',
      'Shadowrun': 'shadowrun',
      'Star Wars Roleplaying Game': 'star-wars',
      'Cyberpunk Red': 'cyberpunk',
      'Eclipse Phase': 'eclipse',
      'Stars Without Number': 'swn',
      'Numenera': 'numenera',
      'Call of Cthulhu': 'coc',
      'World of Darkness': 'wod',
      'Vampire: The Masquerade': 'vtm',
      'Delta Green': 'delta-green',
      'Monster of the Week': 'motw',
      'Kult: Divinity Lost': 'kult',
      'Hunter: The Reckoning': 'hunter',
      'Unknown Armies': 'unknown-armies',
      'Other': 'other'
    };

    return {
      genre: genreMapping[label] || '',
      system: systemMapping[value] || ''
    };
  }
}
